var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenHooper(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 25,
    viewBox: "0 0 90 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.59 16.114h.475V10.86h-.475v5.254zM9.45 16.114h.476V10.86H9.45v5.254z",
    fill: "gray"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.759 11.255h3.306v-.395h-3.17l-.136.395z",
    fill: "gray"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m5.953 16.423.457.11 1.844-5.278.136-.395h-.494l-.137.395-1.806 5.168zM73.24 17.576V9.203h-.772v8.373h.772z",
    fill: "gray"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.32 19.17v-5.854h-3.19v5.854h3.19zM82.48 17.574V9.202h-.772v8.372h.773z",
    fill: "gray"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.479 8.93H63.92v.642h18.558V8.93z",
    fill: "gray"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.627 20.169H25.293v.358h11.334v-.358zM61.954 20.169H50.62v.358h11.334v-.358z",
    fill: "#666"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.314 20.434V19.04h-.432v1.394h.431zM55.83 20.434V19.04h-.432v1.394h.431zM31.955 20.434V19.04h-.431v1.394h.431zM34.597 20.434V19.04h-.432v1.394h.432z",
    fill: "#666"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.263 19.142H35.447v.218h12.816v-.218zM48.263 20.494H35.447v.218h12.816v-.218zM70.948 13.077H60.092v.24h10.856v-.24zM64.07 14.11h-9.365v.24h9.364v-.24zM64.07 15.048h-9.365v.24h9.364v-.24z",
    fill: "gray"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.031 12.121h-4.615c-.2 0-.362.135-.362.3v1.788c0 .166.162.3.362.3h4.615c.2 0 .363-.134.363-.3v-1.787c0-.166-.163-.3-.363-.3z",
    fill: "gray"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.396 12.422v.405h-5.342v-.405c0-.04.01-.079.027-.115a.304.304 0 0 1 .079-.098.376.376 0 0 1 .117-.065.427.427 0 0 1 .139-.023h4.615c.097 0 .189.032.257.088a.28.28 0 0 1 .108.213z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.396 13.806v.403a.28.28 0 0 1-.108.213.406.406 0 0 1-.257.088h-4.615a.403.403 0 0 1-.256-.088.278.278 0 0 1-.106-.213v-.403h5.342z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M36.892 17.643H23.615v2.056h13.277v-2.056zM60.938 17.643H47.661v2.056h13.277v-2.056z",
    fill: "#1A1A1A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M84.828 18.139c.906.182 1.788.437 2.635.76.855.34 1.59.858 2.13 1.504l-.174.1a4.81 4.81 0 0 0-.908-.837 5.925 5.925 0 0 0-1.138-.617 14.9 14.9 0 0 0-2.598-.746l.053-.164z",
    fill: "#4D4D4D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m89.994 20.762-.087-.103-.11.064.086.103.11-.064zM89.787 20.88l-.087-.103-.11.064.086.104.11-.064z",
    fill: "#CCC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m89.725 20.328.274.327-.43.248-.275-.326a.103.103 0 0 1-.023-.09.12.12 0 0 1 .06-.076l.196-.114a.167.167 0 0 1 .107-.02c.037.006.07.024.092.05l-.001.001zM6.047 18.139c-.905.182-1.788.437-2.635.76-.855.34-1.589.858-2.13 1.504l.177.1c.257-.311.562-.593.907-.837.348-.242.73-.45 1.137-.617a14.909 14.909 0 0 1 2.606-.746l-.062-.164z",
    fill: "#4D4D4D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m.996 20.828.087-.103-.11-.064-.087.103.11.064zM1.199 20.945l.086-.104-.11-.064-.087.104.11.064z",
    fill: "#CCC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m1.594 20.578-.274.327-.43-.249.274-.327a.149.149 0 0 1 .092-.049.167.167 0 0 1 .107.02l.197.114a.12.12 0 0 1 .06.076.103.103 0 0 1-.024.089l-.002-.001z",
    fill: "#4D4D4D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M87.002 18.709h1.947c.255 0 .461-.172.461-.383v-1.197c0-.211-.206-.383-.46-.383h-1.948c-.254 0-.46.172-.46.383v1.197c0 .211.206.383.46.383z",
    fill: "#333"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M86.56 17.016a.547.547 0 0 1 .134-.016h1.947c.123 0 .24.04.327.112a.355.355 0 0 1 .136.27v1.197a.394.394 0 0 1-.019.112.471.471 0 0 0 .234-.138.343.343 0 0 0 .09-.227v-1.198c0-.05-.012-.1-.035-.147a.386.386 0 0 0-.1-.123.473.473 0 0 0-.15-.083.54.54 0 0 0-.175-.028h-1.947a.526.526 0 0 0-.275.074.393.393 0 0 0-.167.195z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m84.716 18.017 3.86.188a.407.407 0 0 0 .137-.017.36.36 0 0 0 .117-.06.292.292 0 0 0 .08-.094.244.244 0 0 0 .028-.112v-.475a.244.244 0 0 0-.028-.113.291.291 0 0 0-.08-.094.36.36 0 0 0-.117-.061.407.407 0 0 0-.137-.017l-3.86.189v.666z",
    fill: "#4D4D4D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m87.751 17.613.762-.005v-.287l-.762.026v.266zM86.838 17.618l.625-.003v-.257l-.625.02v.24zM86.077 17.625l.522-.005v-.232l-.522.017v.22zM85.438 17.629l.441-.004v-.213l-.442.014v.203zM87.751 18.02l.762.026v-.285l-.762-.005v.264zM86.838 17.988l.625.021v-.256l-.625-.004v.24zM86.077 17.962l.522.02v-.234l-.522-.004v.218zM85.438 17.941l.441.016v-.215l-.442-.004v.203zM88.799 18.893h-.247a.234.234 0 0 1-.148-.05.161.161 0 0 1-.062-.124v-.13h.676v.13a.15.15 0 0 1-.017.068.178.178 0 0 1-.048.058.222.222 0 0 1-.071.037.25.25 0 0 1-.083.011zM87.698 18.893h-.246a.234.234 0 0 1-.149-.05.16.16 0 0 1-.062-.124v-.13h.676v.13a.15.15 0 0 1-.017.068.178.178 0 0 1-.048.058.221.221 0 0 1-.07.037.25.25 0 0 1-.084.011zM.978 18.506l-.829-.319a.244.244 0 0 1-.105-.076.185.185 0 0 1-.04-.112v-.544c0-.04.013-.079.04-.112a.243.243 0 0 1 .105-.078l.83-.316v1.556z",
    fill: "#333"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M.979 16.949v.1l-.695.265a.274.274 0 0 0-.12.087.208.208 0 0 0-.044.126v.612a.216.216 0 0 0 0 .036.23.23 0 0 1-.087-.074A.18.18 0 0 1 0 18v-.546c0-.04.014-.078.04-.111a.245.245 0 0 1 .105-.077l.834-.318z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49 17.044v1.368a.274.274 0 0 1-.104.21.398.398 0 0 1-.253.087H1.124a.41.41 0 0 1-.242-.079.299.299 0 0 1-.086-.099.248.248 0 0 1-.03-.12v-1.367c0-.08.038-.155.105-.21a.398.398 0 0 1 .253-.087h1.009c.08 0 .158.022.221.063a.296.296 0 0 1 .126.164c.007.023.01.046.01.07z",
    fill: "#333"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M2.48 16.974H1.217c-.183 0-.33.206-.33.457v1.2a.299.299 0 0 1-.087-.1.248.248 0 0 1-.03-.12v-1.367c0-.08.038-.155.105-.21a.398.398 0 0 1 .253-.087h1.009c.08 0 .156.023.218.064a.295.295 0 0 1 .125.163z",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m5.392 18.017-3.86.188a.407.407 0 0 1-.137-.017.36.36 0 0 1-.117-.06.292.292 0 0 1-.08-.094.244.244 0 0 1-.028-.112v-.475c0-.039.01-.077.028-.113a.291.291 0 0 1 .079-.094.36.36 0 0 1 .118-.061.408.408 0 0 1 .137-.017l3.86.189v.666z",
    fill: "#4D4D4D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m2.357 17.613-.764-.005v-.287l.764.026v.266zM3.272 17.618l-.626-.003v-.257l.626.02v.24zM4.029 17.625l-.52-.005v-.232l.52.017v.22zM4.667 17.629l-.44-.004v-.213l.44.014v.203zM2.357 18.02l-.764.026v-.285l.764-.005v.264zM3.272 17.988l-.626.021v-.256l.626-.004v.24zM4.029 17.962l-.52.02v-.234l.52-.004v.218zM4.667 17.941l-.44.016v-.215l.44-.004v.203z",
    fill: "#333"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M73.278 19.699H61.184l-5.439-1.46h27.83L73.278 19.7z",
    fill: "#666"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M73.278 19.699H61.184l-5.439-1.46h27.83L73.278 19.7z",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.278 19.41H61.184l-5.439-1.46h27.83l-10.297 1.46z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M71.007 16.524h-7.55v2.938h7.55v-2.938z",
    fill: "#1A1A1A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M72.796 19.168H61.663c-.563 0-1.02.379-1.02.847v1.022c0 .468.457.847 1.02.847h11.133c.563 0 1.02-.379 1.02-.847v-1.022c0-.468-.457-.848-1.02-.848z",
    fill: "#333"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M67.126 20.794h-2.075v.262h2.075v-.262zM67.126 21.266h-2.075v.262h2.075v-.262zM67.126 20.324h-2.075v.262h2.075v-.262z",
    fill: "#4D4D4D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m67.126 20.586-2.075.486v-.264l2.075-.484v.262z",
    fill: "gray"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M67.126 21.736h-2.075v.262h2.075v-.262zM67.126 22.217h-2.075v.262h2.075v-.262z",
    fill: "#4D4D4D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m67.126 21.056-2.075.486v-.262l2.075-.486v.262zM67.126 21.528l-2.075.486v-.264l2.075-.484v.262zM67.126 21.998l-2.075.486v-.262l2.075-.486v.262z",
    fill: "gray"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M67.126 19.853h-2.075v.262h2.075v-.262z",
    fill: "#4D4D4D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m67.126 20.117-2.075.484v-.262l2.075-.486v.264z",
    fill: "gray"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M69.411 20.794h-2.075v.262h2.075v-.262zM69.411 21.266h-2.075v.262h2.075v-.262zM69.411 20.324h-2.075v.262h2.075v-.262z",
    fill: "#4D4D4D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m69.411 20.586-2.075.486v-.264l2.075-.484v.262z",
    fill: "gray"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M69.411 21.736h-2.075v.262h2.075v-.262zM69.411 22.217h-2.075v.262h2.075v-.262z",
    fill: "#4D4D4D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m69.411 21.056-2.075.486v-.262l2.075-.486v.262zM69.411 21.528l-2.075.486v-.264l2.075-.484v.262zM60.75 24.03a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5z",
    fill: "gray"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M60.75 23.814a2.534 2.534 0 1 0 0-5.068 2.534 2.534 0 0 0 0 5.068z",
    fill: "#4D4D4D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M62.517 21.28a1.767 1.767 0 1 1-3.533.003 1.767 1.767 0 0 1 3.533-.003z",
    fill: "#333"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3 21.28a.553.553 0 1 1-1.104 0 .553.553 0 0 1 1.105 0z",
    fill: "#4D4D4D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M73.75 24.03a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5z",
    fill: "gray"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M73.75 23.814a2.534 2.534 0 1 0 0-5.068 2.534 2.534 0 0 0 0 5.068z",
    fill: "#4D4D4D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M75.517 21.28a1.767 1.767 0 1 1-3.533.003 1.767 1.767 0 0 1 3.533-.003z",
    fill: "#333"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3 21.28a.553.553 0 1 1-1.104 0 .553.553 0 0 1 1.105 0z",
    fill: "#4D4D4D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m69.411 21.998-2.075.486v-.262l2.075-.486v.262z",
    fill: "gray"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M69.411 19.853h-2.075v.262h2.075v-.262z",
    fill: "#4D4D4D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m69.411 20.117-2.075.484v-.262l2.075-.486v.264z",
    fill: "gray"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M75.158 19.861a1.038 1.038 0 0 0-.33-.223 1.222 1.222 0 0 0-.409-.097l-4.6-.29h-5.175l-4.6.29c-.16.01-.316.05-.454.117-.139.067-.257.16-.346.27a.79.79 0 0 0-.167.369.734.734 0 0 0 .044.392l.337.846h3.351l1.286 1.2c.094.09.21.16.34.209.129.048.27.073.412.073h4.769c.142 0 .283-.025.413-.073.13-.049.246-.12.34-.209l1.284-1.2h3.353l.335-.846a.733.733 0 0 0 .037-.433.816.816 0 0 0-.22-.395zm-11.156 1.223a.18.18 0 0 1-.037.107.235.235 0 0 1-.1.075.29.29 0 0 1-.256-.02l-1.196-.749v-.442c0-.046.023-.09.062-.123a.234.234 0 0 1 .149-.051H63.8c.056 0 .11.018.15.05.039.033.061.078.061.124l-.008 1.03zm5.557.937a.322.322 0 0 1-.123.247.468.468 0 0 1-.298.102h-3.814a.468.468 0 0 1-.297-.102.322.322 0 0 1-.124-.247v-1.777c0-.093.045-.182.124-.247a.468.468 0 0 1 .297-.103h3.814c.112 0 .219.037.298.103a.322.322 0 0 1 .123.247v1.777zm2.473-1.524-1.193.75a.29.29 0 0 1-.257.02.235.235 0 0 1-.1-.076.18.18 0 0 1-.037-.107v-1.029c0-.046.023-.09.062-.123a.234.234 0 0 1 .149-.051h1.174c.056 0 .11.018.15.05.039.033.06.078.06.124l-.008.442z",
    fill: "gray"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M61.386 20.717h-1.097c-.122 0-.22.082-.22.184v.91c0 .101.098.183.22.183h1.097c.122 0 .221-.082.221-.183v-.91c0-.102-.099-.184-.221-.184zM74.173 20.717h-1.097c-.122 0-.22.082-.22.184v.91c0 .101.098.183.22.183h1.097c.122 0 .221-.082.221-.183v-.91c0-.102-.099-.184-.22-.184z",
    fill: "#4D4D4D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M23.372 19.699H11.276l-5.44-1.46h22.975l-5.44 1.46z",
    fill: "#666"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M23.372 19.699H11.276l-5.44-1.46h22.975l-5.44 1.46z",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.372 19.41H11.276l-5.44-1.46h22.975l-5.44 1.46z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M21.099 16.524h-7.55v2.938h7.55v-2.938z",
    fill: "#1A1A1A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M22.89 19.168H11.756c-.564 0-1.02.379-1.02.847v1.022c0 .468.456.847 1.02.847H22.89c.564 0 1.021-.379 1.021-.847v-1.022c0-.468-.457-.848-1.02-.848z",
    fill: "#333"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 24.03a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5z",
    fill: "gray"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 23.814a2.534 2.534 0 1 0 0-5.068 2.534 2.534 0 0 0 0 5.068z",
    fill: "#4D4D4D"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M12.517 21.28a1.767 1.767 0 1 1-3.533.003 1.767 1.767 0 0 1 3.533-.003z",
    fill: "#333"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3 21.28a.553.553 0 1 1-1.104 0 .553.553 0 0 1 1.105 0z",
    fill: "#4D4D4D"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 24.03a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5z",
    fill: "gray"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 23.814a2.534 2.534 0 1 0 0-5.068 2.534 2.534 0 0 0 0 5.068z",
    fill: "#4D4D4D"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M25.517 21.28a1.767 1.767 0 1 1-3.533.003 1.767 1.767 0 0 1 3.533-.003z",
    fill: "#333"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3 21.28a.553.553 0 1 1-1.104 0 .553.553 0 0 1 1.105 0zM17.22 20.794h-2.075v.262h2.075v-.262zM17.22 21.266h-2.075v.262h2.075v-.262zM17.22 20.324h-2.075v.262h2.075v-.262z",
    fill: "#4D4D4D"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "m17.22 20.586-2.075.486v-.264l2.075-.484v.262z",
    fill: "gray"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M17.22 21.736h-2.075v.262h2.075v-.262zM17.22 22.217h-2.075v.262h2.075v-.262z",
    fill: "#4D4D4D"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "m17.22 21.056-2.075.486v-.262l2.075-.486v.262zM17.22 21.528l-2.075.486v-.264l2.075-.484v.262zM17.22 21.998l-2.075.486v-.262l2.075-.486v.262z",
    fill: "gray"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M17.22 19.853h-2.075v.262h2.075v-.262z",
    fill: "#4D4D4D"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "m17.22 20.117-2.075.484v-.262l2.075-.486v.264z",
    fill: "gray"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M19.503 20.794h-2.075v.262h2.075v-.262zM19.503 21.266h-2.075v.262h2.075v-.262zM19.503 20.324h-2.075v.262h2.075v-.262z",
    fill: "#4D4D4D"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "m19.505 20.586-2.077.486v-.264l2.077-.484v.262z",
    fill: "gray"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M19.503 21.736h-2.075v.262h2.075v-.262zM19.503 22.217h-2.075v.262h2.075v-.262z",
    fill: "#4D4D4D"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "m19.505 21.056-2.077.486v-.262l2.077-.486v.262zM19.505 21.528l-2.077.486v-.264l2.077-.484v.262zM19.505 21.998l-2.077.486v-.262l2.077-.486v.262z",
    fill: "gray"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M19.503 19.853h-2.075v.262h2.075v-.262z",
    fill: "#4D4D4D"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "m19.505 20.117-2.077.484v-.262l2.077-.486v.264z",
    fill: "gray"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M25.261 19.861a1.04 1.04 0 0 0-.33-.223 1.22 1.22 0 0 0-.41-.097l-4.6-.29h-5.184l-4.6.29c-.16.01-.316.05-.455.116a1 1 0 0 0-.346.27.79.79 0 0 0-.168.37.733.733 0 0 0 .044.392l.337.846h3.353l1.284 1.2c.095.09.213.162.344.21.131.049.274.073.418.072h4.759c.142 0 .283-.025.413-.073.13-.049.246-.12.34-.209l1.284-1.2h3.353l.337-.846a.732.732 0 0 0 .041-.432.812.812 0 0 0-.214-.396zm-11.155 1.223a.18.18 0 0 1-.037.107.235.235 0 0 1-.1.075.29.29 0 0 1-.257-.02l-1.195-.749v-.442c0-.046.022-.09.062-.123a.234.234 0 0 1 .148-.051h1.168c.056 0 .11.018.15.05.039.033.06.078.06.124v1.03zm5.557.937a.322.322 0 0 1-.124.247.468.468 0 0 1-.297.102h-3.825a.468.468 0 0 1-.297-.102.322.322 0 0 1-.124-.247v-1.777c0-.093.045-.182.124-.247a.468.468 0 0 1 .297-.103h3.812c.112 0 .219.037.298.103a.322.322 0 0 1 .123.247l.013 1.777zm2.475-1.524-1.196.75a.29.29 0 0 1-.257.02.235.235 0 0 1-.099-.076.18.18 0 0 1-.037-.107v-1.029c0-.046.022-.09.061-.123a.235.235 0 0 1 .15-.051h1.176c.056 0 .11.018.149.05.04.033.061.078.061.124l-.008.442z",
    fill: "gray"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M11.48 20.717h-1.097c-.122 0-.22.082-.22.184v.91c0 .101.098.183.22.183h1.097c.122 0 .22-.082.22-.183v-.91c0-.102-.098-.184-.22-.184zM24.264 20.717h-1.097c-.122 0-.22.082-.22.184v.91c0 .101.098.183.22.183h1.097c.122 0 .22-.082.22-.183v-.91c0-.102-.098-.184-.22-.184z",
    fill: "#4D4D4D"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M86.003 17.138H3.407v1.137h82.596v-1.137z",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.363 17.837v-.26H4.047v.26h81.316z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M63.98 13.488h-3.115c-.167 0-.302.112-.302.25v1.922c0 .138.135.25.301.25h3.116c.166 0 .3-.112.3-.25v-1.922c0-.138-.134-.25-.3-.25z",
    fill: "gray"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.735 13.678h-2.627c-.14 0-.255.094-.255.211v1.62c0 .117.114.211.255.211h2.627c.14 0 .255-.094.255-.211v-1.62c0-.117-.114-.211-.255-.211z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.2
  }), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "m45.173 15.188-.55.468-.286.244-.743.633-.482.409-.26.223-.575.49-.17.146-5.044 4.302H34.01l-5.043-4.302-.745-.636-.743-.632-.19-.16-.55-.473-.33-.28-.509-.432h19.274z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.873 17.709h-2.671c-.475 0-.86.32-.86.713v1.637c0 .394.385.713.86.713h2.67c.475 0 .86-.32.86-.713v-1.637c0-.394-.385-.713-.86-.713z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M36.688 18.936h-2.304a.364.364 0 0 1-.12-.02.32.32 0 0 1-.1-.055.26.26 0 0 1-.068-.083.22.22 0 0 1-.024-.099c0-.069.033-.134.091-.183a.347.347 0 0 1 .22-.076h2.305c.041 0 .082.007.12.02a.317.317 0 0 1 .1.056.257.257 0 0 1 .067.084.219.219 0 0 1 .023.099.237.237 0 0 1-.09.182.344.344 0 0 1-.22.075zM36.688 20.057h-2.304a.367.367 0 0 1-.12-.019.32.32 0 0 1-.1-.055.26.26 0 0 1-.068-.084.22.22 0 0 1 0-.197.26.26 0 0 1 .068-.084.32.32 0 0 1 .1-.055.364.364 0 0 1 .12-.02h2.304c.083 0 .161.027.22.076.057.048.09.113.09.181a.237.237 0 0 1-.09.182.344.344 0 0 1-.22.075zM58.656 15.188l-.374.317-.461.395h-.002l-.741.633-.745.632-.743.636-5.043 4.302h-3.054l-5.046-4.302-.17-.146-.573-.49-.26-.223-.483-.41-.01-.008-.733-.624-.149-.127-.686-.585h19.273z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.355 17.709h-2.671c-.474 0-.859.32-.859.713v1.637c0 .394.385.713.859.713h2.67c.475 0 .86-.32.86-.713v-1.637c0-.394-.385-.713-.86-.713z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M50.172 18.935h-2.305a.367.367 0 0 1-.119-.019.32.32 0 0 1-.101-.055.262.262 0 0 1-.068-.084.22.22 0 0 1-.023-.098.241.241 0 0 1 .095-.178.348.348 0 0 1 .216-.072h2.305c.04 0 .081.006.119.02a.317.317 0 0 1 .1.056.257.257 0 0 1 .067.084.219.219 0 0 1 .023.098.24.24 0 0 1-.094.176.346.346 0 0 1-.215.072zM50.172 20.057h-2.305a.367.367 0 0 1-.119-.019.32.32 0 0 1-.101-.055.26.26 0 0 1-.068-.084.22.22 0 0 1 0-.197.26.26 0 0 1 .068-.084.32.32 0 0 1 .101-.055.364.364 0 0 1 .12-.02h2.304c.082 0 .16.027.219.076.058.048.09.113.09.181a.237.237 0 0 1-.09.182.344.344 0 0 1-.22.075z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m58.656 15.188-.374.317-.461.395h-.002l-.741.633-.745.632-.743.636-5.044 4.302h-3.053l-5.046-4.302-.17-.146-.17.146-5.044 4.302H34.01l-5.043-4.302-.745-.636-.743-.632-.19-.16-.55-.473-.33-.28-.509-.432h2.103l.663.712.587.633.585.632.588.636 3.584 3.865h3.054l3.583-3.865.589-.636.208-.223.834-.902.835.902.209.223.59.636 3.581 3.865h3.055l3.584-3.865.585-.636.587-.632.588-.633.66-.713h2.105z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M69.244.693v4.172l-10.08 9.837-.882.86-.996.971H27.268l-.861-.84L15.31 4.865V.693h53.934z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.93 3.114 11.68 13.419h-.342L15.31 4.865V.695l.62-.514v2.933zM69.244.694v4.17L57.288 16.534h-.343L68.627 3.114V.182l.617.512z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.056 2.18h3.675v2.4h-3.675v-2.4zm0 3.136h3.675v2.062h-3.675V5.316zm0 2.795h3.675v2.066h-3.675V8.11zm0 2.796h3.675v2.067h-3.675v-2.067zM45.504 2.18h3.673v2.4h-3.673v-2.4zm0 3.136h3.673v2.062h-3.673V5.316zm0 2.795h3.673v2.066h-3.673V8.11zm0 2.796h3.673v2.067h-3.673v-2.067zM40.95 2.18h3.675v2.4h-3.675v-2.4zm0 3.136h3.675v2.062h-3.675V5.316zm0 2.795h3.675v2.066h-3.675V8.11zm0 2.796h3.675v2.067h-3.675v-2.067zM36.396 2.18h3.673v2.4h-3.673v-2.4zm0 3.136h3.673v2.062h-3.673V5.316zm0 2.795h3.673v2.066h-3.673V8.11zm0 2.796h3.673v2.067h-3.673v-2.067zM31.844 2.18h3.67v2.4h-3.67v-2.4zm0 3.136h3.67v2.062h-3.67V5.316zm0 2.795h3.67v2.066h-3.67V8.11zm0 2.796h3.67v2.067h-3.67v-2.067zM27.289 2.18h3.675v2.4h-3.675v-2.4zm0 3.136h3.675v2.062h-3.675V5.316zm0 2.795h3.675v2.066h-3.675V8.11zm0 4.866v-2.072h3.675v2.069l-3.675.003zm4.555 3.56V13.71h3.67v2.829l-3.67-.003zm4.552 0V13.71h3.673v2.829l-3.673-.003zm4.555 0V13.71h3.675v2.829l-3.675-.003zm4.553 0V13.71h3.673v2.829l-3.673-.003zm8.227 0h-3.675V13.71h3.675v2.825zM54.61 2.18h3.673v2.4h-3.673v-2.4zm0 3.136h3.673v2.062h-3.673V5.316zm0 2.795h3.673v2.066h-3.673V8.11zm0 4.866v-2.072h3.673v2.069l-3.673.003zM15.31.906v1.273h11.1v13.522l.21.207.648.632h.02v-2.829h3.676v2.829h-3.486l.743.633.745.636H42.1l.169-.147.17.146h13.142l.743-.636.746-.632h-2.46v-2.829h3.672v1.857l.882-.86V2.18h10.088V.906H15.311z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M70.514 1.54H14.04a.852.852 0 0 1-.54-.186.587.587 0 0 1-.225-.448c.001-.168.082-.33.225-.448a.852.852 0 0 1 .54-.187h56.475a.85.85 0 0 1 .54.187c.142.119.222.28.222.448 0 .168-.08.329-.223.448a.85.85 0 0 1-.539.186z",
    fill: "#757575"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M69.799 16.744V.271h-1.526v16.473h1.526z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.799 16.744V.271h-1.526v16.473h1.526z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M16.28 16.746V.273h-1.526v16.473h1.526z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.28 16.746V.273h-1.526v16.473h1.526z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M16.722 16.29 26.62 1.509 25.286.893l-9.898 14.781 1.334.616z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.722 16.29 26.62 1.509 25.286.893l-9.898 14.781 1.334.616z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M69.172 15.675 59.273.894l-1.333.615 9.898 14.781 1.334-.615z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.172 15.675 59.273.894l-1.333.615 9.898 14.781 1.334-.615z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M26.781 16.746V.273h-.88v16.473h.88z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.781 16.746V.273h-.88v16.473h.88z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M31.334 16.744V.271h-.88v16.473h.88z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.334 16.744V.271h-.88v16.473h.88z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M35.889 16.744V.271h-.88v16.473h.88z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.889 16.744V.271h-.88v16.473h.88z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M40.441 16.746V.273h-.88v16.473h.88z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.441 16.746V.273h-.88v16.473h.88z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M44.994 16.744V.271h-.88v16.473h.88z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.994 16.744V.271h-.88v16.473h.88z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M49.549 16.746V.273h-.88v16.473h.88z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.549 16.746V.273h-.88v16.473h.88z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M54.102 16.744V.271h-.88v16.473h.88z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.102 16.744V.271h-.88v16.473h.88z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M58.654 16.744V.271h-.88v16.473h.88z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.654 16.744V.271h-.88v16.473h.88z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M26.34 4.676h31.875v-.73H26.34v.73z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.34 4.676h31.875v-.73H26.34v.73z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M26.34 7.475h31.875v-.73H26.34v.73z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.34 7.475h31.875v-.73H26.34v.73z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M26.34 10.273h31.875v-.73H26.34v.73z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.34 10.273h31.875v-.73H26.34v.73z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M26.34 13.072h31.875v-.73H26.34v.73z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.34 13.072h31.875v-.73H26.34v.73z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M84.215 17.167H5.2c0-.336.161-.658.447-.896a1.698 1.698 0 0 1 1.08-.37h75.963c.405 0 .793.133 1.08.37.285.238.446.56.446.896z",
    fill: "#757575"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.215 17.167H5.2c0-.336.161-.658.447-.896a1.698 1.698 0 0 1 1.08-.37h75.963c.405 0 .793.133 1.08.37.285.238.446.56.446.896z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M62.546 13.885H62.3v1.663h.246v-1.663z",
    fill: "#333"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M63.298 14.831v-.234h-1.75v.234h1.75z",
    fill: "#333"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M62.424 15.75c-.215 0-.426-.06-.605-.174a1.047 1.047 0 0 1-.402-.463.988.988 0 0 1-.062-.598c.041-.201.145-.386.297-.53.152-.146.346-.244.557-.284.211-.04.43-.02.63.058.198.079.368.211.488.381s.184.37.184.575c-.001.274-.116.537-.319.73a1.12 1.12 0 0 1-.768.305zm0-1.833a.873.873 0 0 0-.467.135.81.81 0 0 0-.31.359.763.763 0 0 0-.048.462.788.788 0 0 0 .23.41.856.856 0 0 0 .431.22c.163.03.333.014.487-.046a.834.834 0 0 0 .377-.295.773.773 0 0 0-.104-1.01.865.865 0 0 0-.596-.235z",
    fill: "#333"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M62.73 14.715a.278.278 0 0 1-.052.16.3.3 0 0 1-.136.107.318.318 0 0 1-.33-.063.275.275 0 0 1-.066-.314.292.292 0 0 1 .112-.13.315.315 0 0 1 .383.036.285.285 0 0 1 .088.204z",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.215 17.148h-.07c-.1-.256-.295-.48-.557-.638a1.758 1.758 0 0 0-.902-.246H6.725c-.325 0-.641.086-.903.245a1.314 1.314 0 0 0-.556.64h-.072c0-.337.162-.66.449-.897a1.7 1.7 0 0 1 1.08-.37h75.961c.201-.001.4.031.585.095.186.063.355.157.497.274.142.118.255.258.332.412.077.153.117.319.117.485z",
    fill: "#fff",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M78.589 18.01h-.381v3.838h.381v-3.839z",
    fill: "#333"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M82.42 21.532h-4.212v.316h4.212v-.316zM82.422 20.052v-.317h-4.214v.317h4.214z",
    fill: "#333"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M82.42 18.01h-.38v3.838h.38v-3.839zM8.945 16.245H7.116v1.19h1.83v-1.19z",
    fill: "#333"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24 15.338h-.427v2.873h.428v-2.873z",
    fill: "#C1272D"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M9.538 16.977v-.407H6.515v.407h3.023z",
    fill: "#C1272D"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M8.028 18.56a1.95 1.95 0 0 1-1.045-.301 1.81 1.81 0 0 1-.693-.802 1.705 1.705 0 0 1-.107-1.033c.072-.347.251-.665.514-.915s.598-.42.963-.49a1.97 1.97 0 0 1 1.087.103c.343.135.637.365.843.659.207.294.316.64.316.993-.001.473-.2.927-.551 1.261a1.932 1.932 0 0 1-1.327.524zm0-3.166c-.287 0-.568.08-.807.232a1.399 1.399 0 0 0-.535.62c-.11.252-.138.53-.082.798.056.267.194.513.397.706.203.194.462.325.744.378.282.054.574.026.84-.078.265-.105.491-.282.651-.509a1.333 1.333 0 0 0-.18-1.744 1.46 1.46 0 0 0-.471-.3 1.518 1.518 0 0 0-.557-.105v.002z",
    fill: "#C1272D"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M8.029 17.273c.29 0 .524-.223.524-.498a.512.512 0 0 0-.524-.499.512.512 0 0 0-.524.499c0 .275.235.498.524.498zM35.695 17.533h-.427v2.874h.427v-2.874z",
    fill: "#C1272D"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M36.992 19.172v-.406H33.97v.406h3.023z",
    fill: "#C1272D"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M35.483 20.755c-.372 0-.736-.105-1.046-.3a1.81 1.81 0 0 1-.693-.803 1.704 1.704 0 0 1-.107-1.033c.072-.346.251-.665.514-.915s.598-.42.963-.49a1.97 1.97 0 0 1 1.087.103c.343.136.637.365.843.66.207.293.317.639.316.993-.001.473-.2.926-.551 1.26a1.933 1.933 0 0 1-1.326.524zm0-3.166c-.288 0-.569.08-.807.233a1.398 1.398 0 0 0-.535.62c-.11.252-.14.53-.083.797.056.268.194.514.397.707.204.193.462.324.744.378.282.053.574.026.84-.079.265-.104.492-.281.651-.508a1.333 1.333 0 0 0-.18-1.745 1.459 1.459 0 0 0-.471-.3 1.517 1.517 0 0 0-.556-.105v.002z",
    fill: "#C1272D"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M35.483 19.468c.29 0 .524-.223.524-.498a.512.512 0 0 0-.524-.498.512.512 0 0 0-.524.498c0 .275.235.498.524.498zM49.195 17.533h-.427v2.874h.427v-2.874z",
    fill: "#C1272D"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M50.492 19.172v-.406H47.47v.406h3.023z",
    fill: "#C1272D"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M48.983 20.755c-.372 0-.736-.105-1.046-.3a1.81 1.81 0 0 1-.693-.803 1.704 1.704 0 0 1-.107-1.033c.072-.346.251-.665.514-.915s.598-.42.963-.49a1.97 1.97 0 0 1 1.087.103c.343.136.637.365.843.66.207.293.317.639.316.993-.001.473-.2.926-.551 1.26a1.933 1.933 0 0 1-1.326.524zm0-3.166c-.288 0-.569.08-.807.233a1.398 1.398 0 0 0-.535.62c-.11.252-.14.53-.083.797.056.268.194.514.397.707.204.193.462.324.744.378.282.053.574.026.84-.079.265-.104.492-.281.651-.508a1.333 1.333 0 0 0-.18-1.745 1.459 1.459 0 0 0-.471-.3 1.517 1.517 0 0 0-.556-.105v.002z",
    fill: "#C1272D"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M48.983 19.468c.29 0 .524-.223.524-.498a.512.512 0 0 0-.524-.498.512.512 0 0 0-.524.498c0 .275.235.498.524.498z",
    fill: "#C1272D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenHooper);
export default __webpack_public_path__ + "static/media/open_hooper.74fd22879808d2cc505f66d9fa121bb5.svg";
export { ForwardRef as ReactComponent };